import React, { useState } from "react";
import axios from "axios";
import mpAPI from "../../../api/admin/mpApi";
import { showError, showSuccess } from "../../../utils/toastUtils";

import { Buffer } from "buffer";
import { saveAs } from "file-saver";

function UploadExcel() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    // try {
    setLoading(true);

    const res = await mpAPI.uploadExcel(formData, {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob",
    });

    if (res.code === 200) {
      setLoading(false);

      console.log("API Response:", res.data.file);

      console.log("Base64 length:", res.data.file.length);

      const byteArray = Buffer.from(res.data.file, "base64");
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // ✅ Save with file-saver
      saveAs(blob, "admins_with_passwords.xlsx");

      setLoading(false);
      showSuccess("✅ File processed successfully!");
    } else {
      setLoading(false);
      showError(res.message);
    }

    // } catch (error) {
    //   console.error(error);
    //   setLoading(false);
    //   showError("❌ Something went wrong!");
    // }
  };

  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title" id="standard-modalLabel">
            Import MP Data
          </h4>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div className="modal-body">
          {/* Download Sample */}
          <div className="mb-4">
            <h5 className="fw-semibold mb-2">
              <i className="bi bi-download" /> Download Sample File
            </h5>
            <p className="text-muted small">
              Download a sample file to understand the required format.
            </p>
            <a
              href={`${process.env.PUBLIC_URL}/excels/mplogin.xlsx`}
              download
              className="btn btn-success w-100 py-2"
            >
              <i className="bi bi-download me-2" /> Download Sample
            </a>
          </div>

          <hr className="my-4" />

          {/* Upload File */}
          <h5 className="fw-semibold mb-3">
            <i className="bi bi-cloud-upload" /> Upload Your File
          </h5>
          <div className="input-group mb-3">
            <input
              type="file"
              accept=".xlsx, .xls"
              className="form-control"
              onChange={handleFileChange}
            />
          </div>

          {file && (
            <div className="alert alert-info py-2">
              <i className="bi bi-file-earmark-excel me-2" />
              {file.name}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleUpload}
            disabled={loading}
          >
            {loading ? "Processing..." : "Upload & Update Data"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UploadExcel;
